import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { PopoverContentProps } from "./popover.types";

/**
 * The `PopoverContent` component works with the `Popover` component and is used to wrap the popover content.
 */
export const PopoverContent: FunctionComponent<PopoverContentProps> = ({
  innerRef,
  style,
  hoverHandlers: popoverHandlers,
  showArrow = false,
  arrowProps = {},
  placement = "",
  className,
  children,
}) => {
  const contentClassName = classNames("bg-white p-4 border-1 border-gray-400 shadow-overlay rounded-2 z-40", className);

  const arrowClassName = classNames({
    top: /^top/.test(placement),
    right: /^right/.test(placement),
    bottom: /^bottom/.test(placement),
    left: /^left/.test(placement),
  });

  return (
    // replace this div with panel
    <div ref={innerRef} style={style} {...popoverHandlers} className={contentClassName}>
      {children}
      {showArrow && (
        <div ref={arrowProps.ref} style={arrowProps.style} className={arrowClassName}>
          *
        </div>
      )}
    </div>
  );
};
